import React, { FC } from 'react'
import { PromptSuccessIcon } from '../../assets/icons'
import { View } from 'react-native'
import { useTranslation } from 'react-i18next'
import { Text } from 'react-native-paper'
import { useResponsive } from '../../utils/hooks'
import { styles } from './styles'
import { BtButton } from '@linqpal/components/src/ui'
import { urls } from '@linqpal/models/src/dictionaries'
import { Spacer } from '../../ui/atoms'

export const AgreementSubmittedMessage: FC = () => {
  const { t } = useTranslation('global')
  const { sm } = useResponsive()

  return (
    <View style={[styles.wrapper, { width: sm ? 590 : 350 }]}>
      <PromptSuccessIcon width={200} height={200} />

      <Text style={styles.title}>
        {t('DocumentApproval.agreement-submitted-title')}
      </Text>
      <Text style={styles.message}>
        {t('DocumentApproval.agreement-submitted-message')}
      </Text>

      <Spacer height={36} />

      <BtButton
        size={'large'}
        style={{ width: 250 }}
        onPress={() => window.location.replace(urls.SignUp)}
      >
        {t('DocumentApproval.setup-account')}
      </BtButton>
    </View>
  )
}
